import React from "react";
import NumberFormat from "react-number-format";

const TokenInput = (props) => (
  <NumberFormat
    autoFocus
    thousandSeparator
    allowNegative={false}
    decimalScale={18}
    isAllowed={(values) => {
      if (!values.floatValue) {
        return true;
      }
      return values?.floatValue < 100000000000;
    }}
    {...props}
  />
);

export default TokenInput;
